import React, { ChangeEvent, useEffect, useState } from "react";
import { DesktopTimePicker, TabContext, TabList, TimePicker } from "@mui/lab";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Switch,
  Tab,
  TextField,
  Typography,
  ToggleButtonGroup,
  ToggleButton
} from "@mui/material";

import AutoCompleteMultiSelect from "../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../../components/TextAreaComponents/TextAreaComponents.tsx";
import { ToastContainer, toast } from "react-toastify";
import Cancel from "./../../../../assets/icons/close.png";
import CancelIcon from "@mui/icons-material/Cancel";
import galleryIcon from "./../../../../assets/icons/gallery.png";

import LoadingView from "./../../../components/LoadingView/LoadingView.js";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal.js";
import axios from "axios";
import jwt_decode from "jwt-decode";

import { uploadOneFiles } from "./../../../../../src/fileUploader/SingleFileUploader.js";

function AddTableDialog(props) {
  // const { title } = props.title
  //Addsection dialog control start
  const [openAddKeyword, setOpenAddKeyword] = useState(false);

  const [openAddSection, setOpenAddSection] = useState(false);

  const [VatName, setVatName] = useState("");
  const [TableName, setTableName] = useState("");
  const [TableDescription, setTableDescription] = useState("");
  const [Parcentage, setParcentage] = useState("");
  const [Noofseats, setNoofseats] = useState(0);
  const [FloorNO, setFloorNO] = useState(0);

  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { dialogType, selectedRestaurant } = props;
  const [selectedValue, setSelectedValue] = useState<any>(null);
  const [loadingModal, SetloadingModal] = React.useState(false);
  const handleClose = () => {
    props.onHandleAddItem(false);
    setSelectedValue(null);
  };

  const [TableInsertView, setTableInsertView] = useState({
    tableId: "",
    tableQRCode: "",
    tableName: "",
    description: "",
    tableImagePath: "",
    totalChairUnderThisTable: 0,
    serailNumber: 0,
    RestaurantId: "",
    isActive: false,
    CreatorId: "",
    floorNumber: 0,
    seatPosition: ""
  });

  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);

  //Addsection dialog controll end

  //image upload code start

  //image upload code end
  const [tokenData, setTokenData] = useState({});

  const restaurant = JSON.parse(localStorage.getItem("restaurant"));

  const [userId, setUserId] = useState();


  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [specificationRows, setSpecificationRows] = React.useState([]);
  const apiAddress = process.env.REACT_APP_SECRET;
  useEffect(() => {
    let FindRes = restaurantDatas.find((dt) => dt.id === selectedRestaurant.id)
    let resList = []
    if (FindRes) {
      resList.push(FindRes)
    }
    setRestaurantAdded(resList)
  }, [props]);

  // const fileUpload = async () => {
  //   var Url = "";
  //   if (imageFile.length == 0) {
  //     setImageErr(true);
  //   }else{
  //     for (let i = 0; i < imageFile.length; i++) {
  //       var res = await uploadOneFiles(imageFile[i]);
  //       var obj = {
  //         Id: "123",
  //         FoodItemId: "123",
  //         ItemImagePath: res[0],
  //         CreationId: "123",
  //       };
  //       //Url=obj;
  //     }
  //   }

  //   // setImageUrl(Url)
  //   if (res[0] != undefined){
  //     TableInsertView.tableImagePath = res[0];
  //   }
  // };

  const fileUpload = async () => {
    let Url = "";
    let res = []; // Declare res array outside loop
  
    if (imageFile.length === 0) {
      setImageErr(true);
      return; // early return if no images
    }else{
      setImageErr(false);
    }
  
    for (let i = 0; i < imageFile.length; i++) {
      const singleRes = await uploadOneFiles(imageFile[i]);
      if (singleRes && singleRes[0]) {
        res.push(singleRes[0]);
  
        const obj = {
          Id: "123",
          FoodItemId: "123",
          ItemImagePath: singleRes[0],
          CreationId: "123",
        };
        // Do something with obj if needed
      }
    }
  
    // Use the first image for table image path (or any logic you want)
    if (res.length > 0) {
      TableInsertView.tableImagePath = res[0];
    }
  };

  const submit = async () => {
    var valid = true;
    if (
      restaurantAdded.length == 0 ||
      restaurantAdded == undefined ||
      restaurantAdded == null
    ) {
      valid = false;
      toast.error("Please select a restaurant", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (TableName == "" || TableName == undefined || TableName == null) {
      valid = false;
      toast.error("Table Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (Noofseats == 0 || Noofseats == undefined || Noofseats == null) {
      valid = false;
      toast.error("Number of seats is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (imageFile.length == 0 || imageFile == undefined || imageFile == null) {
      valid = false;
      toast.error("Image is not valid", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (alignment == null) {
      valid = false;
      toast.error("Seat position is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    TableInsertView.tableId = "";
    TableInsertView.tableQRCode = "";
    TableInsertView.tableName = TableName;
    TableInsertView.description = TableDescription;
    TableInsertView.totalChairUnderThisTable = Noofseats;
    TableInsertView.serailNumber = 0;
    TableInsertView.RestaurantId = restaurantAdded[0]?.id;
    TableInsertView.isActive = true;
    TableInsertView.CreatorId = "";

    await fileUpload();

    if (valid) {
      TableInsertView.tableId = "";
      TableInsertView.tableQRCode = "";
      TableInsertView.tableName = TableName;
      TableInsertView.description = TableDescription;
      TableInsertView.totalChairUnderThisTable = Noofseats;
      TableInsertView.serailNumber = 0;
      TableInsertView.RestaurantId = restaurantAdded[0].id;
      TableInsertView.isActive = true;
      TableInsertView.CreatorId = "";
      TableInsertView.floorNumber = FloorNO;
      TableInsertView.seatPosition = alignment;

      SetloadingModal(true);
      await fileUpload;
      axios({
        method: "post",
        url: apiAddress + "/api/RestaurantTable/InsertRestaurantTableInfo",
        data: TableInsertView,
      }).then((response) => {
        setTableName("");
        setTableDescription("");
        setNoofseats(0)
        setRestaurantAdded([]);
        handleDeleteImage(0);

        setopenConfirmaitonModal(false);
        props.onHandleAddItem(false);
        setIsSubmitting(false);
        SetloadingModal(false);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
    }
  };

  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestauranttokenLocal = JSON.parse(localStorage.getItem("restaurant"));

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");

  useEffect(() => {
    loadRestaurantName();
  }, []);

  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) { }
    }

    axios

      .get(
        apiAddress +
        `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };

  const [restaurantAdded, setRestaurantAdded] = useState([]);

  const restaurantAddedvalue = (props) => {
    if (props.length > 1) {
      toast.error("You can only select one restaurant at a time.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    if (props.length === 1) {
      // Allow only reducing schedules, no more additions
      setRestaurantAdded(props);
    }

    if (props.length === 0) {
      // Allow adding a schedule when no schedules exist
      setRestaurantAdded(props);
    }
  };

  interface ImageUploadState {
    // selectedImage: string | null
    selectedImages: string[];
  }

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [],
  });
  const [ImageErr, setImageErr] = useState(false);

  const [imageFile, setImageFile] = useState([]);
  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 1 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        setImageFile((prevItems) => [...prevItems, file]);

        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
    setImageErr(false);
  };

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    const updateImageFile = [...imageFile];
    updatedImages.splice(index, 1);
    updateImageFile.splice(index, 1);
    setImageFile(updateImageFile);
    setState({ selectedImages: updatedImages });
  };

  const [alignment, setAlignment] = React.useState('inside');

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignment(newAlignment);
  };

    const closeLoadingModal = () => {
    SetloadingModal(false);
  };


  return (
    <div>
      <React.Fragment>
        <Dialog
          fullWidth={true}
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />

          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this?"}
            open={openConfirmaitonModal}
            onyes={submit}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
            disableYesButton={isSubmitting}
          />
          <ToastContainer />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <div style={{ padding: "10px" }}>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <div
                  className="d-flex"
                  style={{ paddingTop: "1rem", gap: "10px" }}
                >
                  <Typography>Restaurant</Typography>
                </div>
              </Grid>
              <Grid item xs={10}>
                <AutoCompleteMultiSelect
                  id={2}
                  multiple={false}
                  placeholder={"Restaurant"}
                  datas={restaurantDatas}
                  value={restaurantAddedvalue}
                  val={restaurantAdded}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Table Name
                </Typography>
              </Grid>
              <Grid item xs={10}>
                {/* <TextAreaComponents
                  label={"Table name"}
                  value={setTableName}
                  val={TableName}
                ></TextAreaComponents> */}
                <TextField
                  id="outlined-basic"
                  value={TableName}
                  placeholder={"Table name"}
                  variant="outlined"
                  fullWidth
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (event.target.value.length <= 10) {
                      setTableName(event.target.value);
                    }
                  }}
                  helperText={'This field is required (Maximum 10 characters)'}
                />
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Description
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  label={"Description"}
                  value={setTableDescription}
                  val={TableDescription}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  No. of Seats
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  id={2}
                  label={"No. of seats"}
                  value={setNoofseats}
                  val={Noofseats}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>
                  Floor No.
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <TextAreaComponents
                  id={2}
                  label={"Floor Number"}
                  value={setFloorNO}
                  val={FloorNO}
                ></TextAreaComponents>
              </Grid>
            </Grid>
            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={2}>
                <Typography style={{ paddingTop: "0.5rem" }}>
                  Seat Location
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  aria-label="Platform"
                >
                  <ToggleButton value="inside">Inside</ToggleButton>
                  <ToggleButton value="outside">Outside</ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid xs={2}>
                <Typography style={{ paddingTop: "1rem" }}>Image</Typography>
              </Grid>
              <Grid xs={9}>
                <Button
                  variant="contained"
                  component="label"
                  //   color="primary"
                  style={{ backgroundColor: "white", color: "gray" }}
                >
                  <img
                    src={galleryIcon}
                    alt="gallery-Icon"
                    style={{ width: "2rem" }}
                  />
                  Upload
                  <input
                    hidden
                    accept="image/*"
                    multiple
                    type="file"
                    onChange={handleImageUpload}
                    disabled={state.selectedImages.length >= 1}
                  />
                </Button>
              </Grid>

              {/* image show start */}
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                  <Grid container spacing={2}>
                    {state.selectedImages.map((image, index) => (
                      <Grid item xs={2} sm={2} md={2} key={index}>
                        {/* <Paper> */}
                        <div
                          style={{
                            position: "relative",
                            paddingTop: "20px",
                          }}
                        >
                          <img
                            src={image}
                            alt={`Preview ${index + 1}`}
                            style={{
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <IconButton
                            style={{
                              position: "absolute",
                              top: "-6px",
                              right: "-23px",
                              color: "gray",
                            }}
                            onClick={() => handleDeleteImage(index)}
                          >
                            <CancelIcon />
                          </IconButton>
                        </div>
                        {/* </Paper> */}
                      </Grid>
                    ))}
                  </Grid>
                  <div style={{ paddingTop: "1rem" }}>
                    {ImageErr && (
                      <span style={{ color: "red" }}>
                        This field is required
                      </span>
                    )}
                  </div>
                </Grid>
              </Grid>
              {/* image show end */}
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
              <Grid item xs={9}></Grid>
              <Grid item xs={2}>
                <Button
                  className="AddItemButtons"
                  onClick={() => setopenConfirmaitonModal(true)}
                >
                  Save
                </Button>
              </Grid>
              <Grid item xs={1}></Grid>
            </Grid>
          </div>
          {/* <DialogActions>
            <Button onClick={handleClose}>Close</Button>
          </DialogActions> */}
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default AddTableDialog;
